/**
 * Counts the ICE candidates carried in an SDP blob.
 *
 * The candidate count is read off the SDP rather than from the peer
 * connection's stats, so it stays available for a connection that has already
 * gathered and moved on.
 */
export const extractIceCandidatesFromSdp = (sdp: string | null): number => {
  if (!sdp) return 0;

  return sdp
    .split(/\r?\n/)
    .filter((line) => line.startsWith('a=candidate:')).length;
};
